import type { BlockType, BlockProps, BlockSettings } from '@brix/types'

export interface BlockProps_ {
  id: string
  pageId: string
  type: BlockType
  props: BlockProps
  settings: BlockSettings
  orderIndex: number
  parentId: string | null
  children?: Block[]
  createdAt: Date
  updatedAt: Date
}

export class Block {
  readonly id: string
  readonly pageId: string
  readonly type: BlockType
  readonly props: BlockProps
  readonly settings: BlockSettings
  readonly orderIndex: number
  readonly parentId: string | null
  readonly children: Block[]
  readonly createdAt: Date
  readonly updatedAt: Date

  private constructor(props: BlockProps_) {
    this.id = props.id
    this.pageId = props.pageId
    this.type = props.type
    this.props = props.props
    this.settings = props.settings
    this.orderIndex = props.orderIndex
    this.parentId = props.parentId
    this.children = props.children ?? []
    this.createdAt = props.createdAt
    this.updatedAt = props.updatedAt
  }

  static reconstitute(props: BlockProps_): Block {
    return new Block(props)
  }

  isContainer(): boolean {
    return this.type === 'grid' || this.type === 'columns'
  }

  withProps(patch: Partial<BlockProps>): Block {
    return new Block({ ...this, props: { ...this.props, ...patch } as BlockProps })
  }

  withSettings(patch: Partial<BlockSettings>): Block {
    return new Block({ ...this, settings: { ...this.settings, ...patch } })
  }

  withOrder(orderIndex: number): Block {
    return new Block({ ...this, orderIndex })
  }
}
